import React from 'react';
import {
  AbsenceApprovalStatus,
  ApprovalRequestStatus,
  usePendingApprovalRequestToMeQuery,
} from '../../../__generated__/graphql';
import ServerError from '../../../../../components/ServerError';
import { mapApprovalRequests } from '../ApprovalRequestsTable/mappings';
import { ApprovalRequestsTable } from '../ApprovalRequestsTable/ApprovalRequestsTable';

export const PendingApprovalRequests: React.FC = () => {
  const { data, loading, error } = usePendingApprovalRequestToMeQuery();

  if (error) {
    return <ServerError />;
  }

  //TODO:: temp solution
  const requests = mapApprovalRequests(data?.me.approvalRequests ?? []).filter(
    (request) => {
      if (request.absence) {
        if (
          request.absence.flair__Approval_Status__c !==
            AbsenceApprovalStatus.Pending &&
          request.approvalStatus === ApprovalRequestStatus.Pending
        ) {
          return false;
        }
      }

      return request.approvalStatus === ApprovalRequestStatus.Pending;
    },
  );

  const filterOutWithoutAbsence = requests.filter((request) => {
    if (request.relatedRecordObjectName !== 'Absence') {
      return true;
    }
    return request.absence !== null;
  });

  return (
    <ApprovalRequestsTable
      requests={filterOutWithoutAbsence}
      loading={loading}
    />
  );
};
